
/**
 * @export
 * @type ProductSubscriptionSort
 */
export type ProductSubscriptionSort = {
    field?: ProductSubscriptionSortField;
    direction?: ProductSubscriptionSortDirection;
}

export enum ProductSubscriptionSortField {
    startDate = 'startDate',
    endDate = 'endDate'
}

export enum ProductSubscriptionSortDirection {
    ASC = 'ASC',
    DESC = 'DESC'
}